const dbRequest            = require ('../../js-network/db-request')
const quickformForm        = require ('./quickform-form')
const snack                = require ('../snack/snack')


export function addOne(detail, htmlQf, callback){ 

  const phpFile = selectPhpFile( htmlQf, 'addOne' )

  DB(detail,  phpFile) 
  .then((result)=>  {  //console.log('addOne>', result)

	  		//prepare the Quickform
			quickformForm.prepareAfterInsert(detail, htmlQf, result)
		  
		  	snack.start( {act:"show", id:"addOk"} )

		  	callback(result.data[0], result) 

  }).catch((error) => {  //console.log('error addOne', error)

  		snack.start({ act:"show", id:"addError"  })
  }) 

}/*addOne*/



async function DB(detail, phpFile){ //console.log('addOnetDB>>>>>>>>>>>>>>>>i', detail)

   const result = await dbRequest.start( detail, phpFile, ) //do the insert
 
   if(result.status != "ok"){ throw ( result ) }
   return result
}



function  selectPhpFile(htmlQf, from){


	switch (from) {

	   case 'addOne':
	   		if( htmlQf.addOne != undefined){  return htmlQf.addOne               }
	   		else                           {  return 'server/php/sql/insert.php' }
	   break;
	}/*switch*/

}/*selectPhpFile*/